import {
  VERIFY_FORMER_CUSTOMER_BEGIN,
  VERIFY_FORMER_CUSTOMER_SUCCESS,
  VERIFY_FORMER_CUSTOMER_FAILURE
} from "./types";

import { GENERIC_ERROR_MESSAGE } from "../../DownloadAndDelete/actions/types";
import API from "../../../../../Services/API";
import { ENDPOINTS } from "utils/endpoints";

function encryptSSN(ssn) {
  if (window.ProtectString && typeof window.ProtectString === "function") {
    const encryptedSSN = window.ProtectString(ssn, null);

    if (encryptedSSN && encryptedSSN.length) {
      return encryptedSSN[0];
    }
  }
  return -1;
}

export const verifyFormerCustomer = (firstName, lastName, ssn, uniqueId, flow) => async dispatch => {
  dispatch({ type: VERIFY_FORMER_CUSTOMER_BEGIN });

  const encryptedSSN = encryptSSN(ssn);
  const isCorrectible = "correction" === flow ? "Y" : "N";
  const isDeletable = "deletion" === flow ? "Y" : "N";

  try {
    const response = await API({
      url: ENDPOINTS.VERIFY_FORMER_CUSTOMER,
      method: "POST",
      data: {
        isCorrectible,
        isDeletable,
        uniqueId,
        fName: firstName,
        lName: lastName,
        encryptedId: `${encryptedSSN} ${window.PIE.key_id} ${window.PIE.phase} PSS`
      }
    });

    if (response && response.status === "OK") {
      dispatch({
        type: VERIFY_FORMER_CUSTOMER_SUCCESS,
        payload: response.data
      });
    } else {
      dispatch({ type: VERIFY_FORMER_CUSTOMER_FAILURE, payload: GENERIC_ERROR_MESSAGE });
    }
  } catch (error) {
    if (error.response && error.response.hasOwnProperty("description")) {
      dispatch({
        type: VERIFY_FORMER_CUSTOMER_FAILURE,
        payload: error.response.description
      });
    } else {
      dispatch({
        type: VERIFY_FORMER_CUSTOMER_FAILURE,
        payload: GENERIC_ERROR_MESSAGE
      });
    }
  }
};
